import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["all", "item", "count"]

  connect() { this.update() }

  toggleAll() {
    this.itemTargets.forEach((item) => { item.checked = this.allTarget.checked })
    this.update()
  }

  update() {
    const selected = this.itemTargets.filter((item) => item.checked).length
    this.allTarget.checked = selected > 0 && selected === this.itemTargets.length
    this.allTarget.indeterminate = selected > 0 && selected < this.itemTargets.length
    this.countTarget.textContent = `Đã chọn ${selected} mục trên trang`
  }
}
